// Button -> Select
// Include the search
// Title

import {Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges} from "@angular/core";
import {MultiMediaBasicInfo} from "src/app/common/models/MultiMediaBasicInfo";
import {ParentMessageType} from "src/app/common/models/ParentMessage";
import {ParentCommunicatorService} from "src/app/services/parent-communicator.service";
import {FetchProperty} from "../../../../common/helpers/fetch-property";
import {ConfirmationDialogService} from "src/app/services/UI/confirmation-dialog.service";
import {MultimediamanagementService} from "../../multimedia/services/multimediamanagement.service";
import {LoadingService} from "src/app/services/UI/loading.service";
import {ApiBaseService} from 'src/app/services/api-base.service';
import {MediaReferences} from '../../../../common/models/MediaReferences';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: "app-mainlazyloading",
    templateUrl: "./mainlazyloading.component.html",
    styleUrls: ["./mainlazyloading.component.scss"],
    standalone: false
})
export class MainlazyloadingComponent implements OnInit, OnChanges {
  @Input() displayList: any[] = [];
  @Input() isFullScreenPopUp: boolean;
  @Input() defaultItemIds: number[];
  @Input() filterTypes: any;
  @Output() selectedItem = new EventEmitter<any>();
  @Output() editItem = new EventEmitter<any>();
  @Output() reload = new EventEmitter<boolean>();
  @Output() deleteItem = new EventEmitter<any>();
  @Input() defaultImageType: string;
  @Input() popupWidth: string;
  @Input() deleteItemId: number;
  // tags, date, place, description, filename, Image caption

  searchText: string = "";
  isItemSelected: boolean = false;
  selectedItemId: number;
  isDropDownOpen: boolean = false;
  selectedDropDownId: number;
  isDefaultItemSelected: boolean = false;
  isDefaultItemDeselected: boolean = false;
  lazyLoadingDisplayItems: MultiMediaBasicInfo[];
  errorItems: number[] = new Array();
  errorImg: string = "../../../../../assets/nonimage-preview/Large-Icons/Broken-Image.png";
  isSaveEnable: boolean = false;
  timeTag: string;
  panelWidth: number;
  marignWidth: number = 50;

  consentBoxOpenCLose: boolean = false;
  confirmationServiceSubscription: any;
  deletingItemId: number;
  confirmationDialogHeader: string;
  confirmationDialogBody: string;
  confirmationDialogfooter: string;
  isFilterDropDownOpen: boolean;

  totalPictures: any;
  totalAudio: any;
  totalVideo: any;
  totalDocuments: any;
  lazyLoadingFilter: any;
  FilterMediaText: any;
  filterMainText: string;

  constructor(
    private parentCommunicatorService: ParentCommunicatorService,
    private fetchProperty: FetchProperty,
    private confirmationDialogService: ConfirmationDialogService,
    private multimediaManagementService: MultimediamanagementService,
    private loadingService: LoadingService,
    private apiBaseService: ApiBaseService,
    private translateService: TranslateService
  ) { }

  ngOnInit(): void {
    this.panelWidth = Number(this.popupWidth.replace('%', ''));
    this.sortDisplayItems();
    this.timeTag = "&timeTag=" + new Date().getTime(); //used to avoid caching

    this.filterMainText = this.filterTypes.find(x => x.id === 0)?.type;
    this.FilterMediaText = this.filterMainText;
    // console.log(this.translate('key'))
  }


  ngOnChanges(changes: SimpleChanges) {

    for (const propName in changes) {
      if (changes.hasOwnProperty(propName)) {
        switch (propName) {
          case 'displayList': {
            if (this.displayList) {
              this.displayList = this.displayList;
              this.sortDisplayItems();
              this.timeTag = "&timeTag=" + new Date().getTime(); //used to avoid caching
            }
          }
          case 'deleteItemId': {
            if (this.deleteItemId > 0) {
              console.log("Delete inside lazyloader");
              this.modifyMediaList(this.deleteItemId);
            }

          }
        }
      }
    }
  }

  ngOnDestroy() {
    if (this.confirmationServiceSubscription) {
      this.confirmationServiceSubscription.unsubscribe();
    }
  }

  selectImage(item) {
    if (item) {
      let isDeselect: boolean = false;
      let isSaveEnable: boolean = false;
      //Double
      if (this.selectedItemId === item.id) {
        if (item.id == this.defaultItemIds[0]) {
          this.selectedItemId = item.id;
          isDeselect = false;
          this.isDefaultItemDeselected = false;
          isSaveEnable = false;
          this.isDefaultItemSelected = true;
        } else {
          this.isItemSelected = false;
          this.selectedItemId = null;
          isDeselect = true;
          this.isDefaultItemDeselected = false;
          isSaveEnable = false;
        }
      } else {
        if (item.id == this.defaultItemIds[0]) {
          this.isDefaultItemDeselected = true;
          this.isItemSelected = false;
          this.selectedItemId = item.id;
          isDeselect = true;
          isSaveEnable = true;
        } else {
          this.isItemSelected = true;
          this.selectedItemId = item.id;
          isDeselect = false;
          this.isDefaultItemDeselected = false;
          isSaveEnable = true;
        }
      }
      let isErrorItem = false;
      if (this.errorItems.includes(item.id)) isErrorItem = true;

      this.isDropDownOpen = false;
      this.selectedItem.emit({ item, isDeselect, isErrorItem, isSaveEnable });
    }
  }

  sortSelectedImagesFirst(
    multiMediaBasicInfo: MultiMediaBasicInfo[]
  ): MultiMediaBasicInfo[] {
    if (
      this.defaultItemIds !== undefined &&
      this.defaultItemIds.length > 0 &&
      multiMediaBasicInfo.length > 0
    ) {
      let itemsInSelected = multiMediaBasicInfo.filter((s) =>
        this.defaultItemIds.includes(s.id)
      );
      let itemsNotInSelected = multiMediaBasicInfo.filter(
        (s) => !this.defaultItemIds.includes(s.id)
      );
      let merged = itemsInSelected.concat(itemsNotInSelected);
      return merged;
    }

    return multiMediaBasicInfo;
  }

  onItemError(item: any, event: any) {
    console.log("onItemError ", item);
    this.errorItems.push(item.id);
    console.log("onItemError list", this.errorItems);
    event.target.src = this.errorImg;
  }

  searchItem() {
    let itemsInSelected = this.displayList.filter(s => this.defaultItemIds.includes(s.id));
    let filteredItems = this.displayList.filter(item =>
      ((item.caption.toLowerCase()).includes(this.searchText.toLowerCase()) // Search by media caption
        || (item.fileName.toLowerCase()).includes(this.searchText.toLowerCase()) // Search by file name
        || (item.tag.toLowerCase()).includes(this.searchText.toLowerCase()) // Search by tag
        || (item.place.toLowerCase()).includes(this.searchText.toLowerCase()) // Search by place
        || (item.description.toLowerCase()).includes(this.searchText.toLowerCase()) // Search by media description
        || (this.fetchProperty.get(item, 'date.formattedText') !== undefined
          && this.fetchProperty.get(item, 'date.formattedText').toLowerCase().includes(this.searchText.toLowerCase())) // Search by date
        || this.searchText === '')
      && !this.defaultItemIds.includes(item.id));
    let merged = itemsInSelected.concat(filteredItems);
    this.lazyLoadingDisplayItems = merged;
    this.lazyLoadingFilter = this.lazyLoadingDisplayItems;
    // self.lazyLoadingList = response.data.filter(x => MultimediaInputresponse.FilterMode.some(y=>y === x.mediaType));
    this.updateMediaCount();
    this.FilterMediaText = this.filterMainText;
  }

  clearSearch() {
    this.lazyLoadingDisplayItems = this.displayList;
  }

  filterMedia(mediaType) {
    if (mediaType == 0) {
      this.lazyLoadingDisplayItems = this.lazyLoadingFilter;
      this.FilterMediaText = this.filterMainText;
    }
    else {
      this.FilterMediaText = this.filterTypes.find(x => x.id === mediaType).type;
      this.lazyLoadingDisplayItems = this.lazyLoadingFilter.filter(x => x.mediaType == mediaType);
    }
  }

  showFilterDropdown() {
    this.isFilterDropDownOpen = !this.isFilterDropDownOpen;
  }

  updateMediaCount() {
    for (let filter of this.filterTypes) {
      filter.count = filter.id == 0 ? this.lazyLoadingFilter.length : this.lazyLoadingDisplayItems.filter(x => x.mediaType === filter.id).length;
    }
  }

  showDropDown(id) {
    this.selectedDropDownId = id;
    this.isDropDownOpen = !this.isDropDownOpen;
    this.isItemSelected = false;
    //this.selectedItem.emit(null);
  }

  hideDropDown() {
    this.isDropDownOpen = false;
  }

  showNotImplemented() {
    this.parentCommunicatorService.send(
      ParentMessageType.ShowInformation,
      "not_implemented"
    );
  }

  openConsent(item) {
    let references: MediaReferences;
    this.isDropDownOpen = !this.isDropDownOpen;
    this.deleteItem.emit(item);
  }

  sortDisplayItems() {
    if (this.defaultItemIds.length > 0) {
      this.isDefaultItemSelected = true;
    } else {
      this.isDefaultItemSelected = false;
    }

    let sortedList = this.sortSelectedImagesFirst(this.displayList);
    this.displayList = sortedList;
    this.searchItem();
  }

  editSelectedItem(item) {
    this.editItem.emit(item);
    this.isDropDownOpen = !this.isDropDownOpen;
  }

  //Modify media list
  modifyMediaList(mediaId) {
    this.lazyLoadingDisplayItems = this.lazyLoadingDisplayItems.filter((s) => s.id !== mediaId).slice();
    this.displayList = this.displayList.filter((s) => s.id !== mediaId).slice();
    this.lazyLoadingFilter = this.displayList;
    this.updateMediaCount();
  }

}
